<template>
  <div class="iphonecontainer _iphonecontainer">
   <NavTop :navid = id />
   <div class="home_box">
       <img v-lazy="backimg" alt="" class="julihe_bannerimg">
       <div>
          <div class="article_box">
           <div class="article_title">{{pname}}</div>
           <div class="article_p" style="margin-bottom:2vh;">{{ptitle}}</div>
           <div class="rongyu_content" v-for="item in list" :key="item.id">
             <div class="rongyu_box">
               <img v-lazy="item.more.thumbnail" alt="" class="rongyu_img">
             </div>
             <div class="rongyu_title">{{item.post_title}}</div>
           </div>
        </div>
       </div>
   </div>
  </div>
</template>

<script>
import NavTop from '../comcomponents/NavTop'
import {rongyulist, getrongyubackimg} from '../../api/jslihe'
export default {
  name: 'iphone',
  components: {
    NavTop
  },
  data () {
    return {
      id: Number(this.$route.query.id),
      list: [],
      backimg: '',
      pname: '',
      ptitle: ''
    }
  },
  mounted () {
    console.log(this.id)
    this.getrongyulist()
  },
  methods: {
    getrongyulist () {
      getrongyubackimg().then(Response => {
        console.log(Response)
        this.backimg = Response.data.more.thumbnail
        this.pname = Response.data.name
        this.ptitle = Response.data.description
      })
      rongyulist({category_id: this.id, limit: 100, page: 1}).then(res => {
        console.log(res)
        this.list = res.data.list
      })
    }
  }
}
</script>

<style lang="less" scoped>
// 小于800px
  .rongyu_content{
     width: 90%;
     margin-left:5%;
    //  margin-top:3rem;
       .rongyu_box{
    padding: 5% 0 5% 0;
    background: #000;
    overflow: hidden;
    .rongyu_img{
      width:90%;
       transition: all 0.5s linear;
    }
    .rongyu_img:hover{
transform: scale(1.2);
transition: all 0.5s linear;
  }
  }
  .rongyu_title{
    color:#555555;
    font-size:0.8rem;
    padding-top:3vh;
    padding-bottom: 4vh;
  }
  }
</style>



// WEBPACK FOOTER //
// src/components/iPhone/iPhone.vue